import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { FOOTPRINT_FOOTER_ID } from '@/idv2/components/constants';
import SecuredByFootprint from '../../secured-by-footprint';
import FooterActions from './footer-actions';
type MobileFooterProps = {
  ref: React.RefObject<HTMLDivElement | null>;
  footerVisible: boolean;
  config?: OnboardingSessionConfig;
  defaultOpen?: boolean;
  footerPosition: 'sticky' | 'relative';
  hideOnDesktop?: boolean;
};
const MobileFooter = forwardRef<HTMLDivElement, MobileFooterProps>((t0, ref) => {
  const $ = _c(12);
  const {
    footerVisible,
    config,
    defaultOpen,
    footerPosition,
    hideOnDesktop
  } = t0;
  const t1 = footerPosition === "sticky";
  const t2 = !footerVisible;
  let t3;
  if ($[0] !== hideOnDesktop || $[1] !== t1 || $[2] !== t2) {
    t3 = cx("relative z-1! flex justify-between pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] px-4 border-t border-tertiary bg-secondary w-full", {
      "min-[900px]:sticky min-[900px]:bottom-0 min-[900px]:z-5!": t1,
      "hidden!": t2,
      "min-[900px]:hidden!": hideOnDesktop
    });
    $[0] = hideOnDesktop;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SecuredByFootprint />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== config || $[6] !== defaultOpen) {
    t5 = <FooterActions config={config} defaultOpen={defaultOpen} />;
    $[5] = config;
    $[6] = defaultOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== ref || $[9] !== t3 || $[10] !== t5) {
    t6 = <footer id={FOOTPRINT_FOOTER_ID} ref={ref} className={t3}>{t4}{t5}</footer>;
    $[8] = ref;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
});
export default MobileFooter;